import { render, staticRenderFns } from "./FeedbacksSection.vue?vue&type=template&id=2496d8a1&scoped=true"
import script from "./FeedbacksSection.vue?vue&type=script&lang=js"
export * from "./FeedbacksSection.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksSection.vue?vue&type=style&index=0&id=2496d8a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2496d8a1",
  null
  
)

export default component.exports